import type { TaskView } from "@common/types/views/tasksView";
import { type NamedView, ViewType } from "@common/types/views/views";
import { DEFAULT_VIEW_ID } from "@components/views/constants";
import { useViewCollection } from "@hooks/view/useViewCollection";
import type { TaskListCacheKeys } from "../taskListCacheKeys";

/**
 * The Tasks page's views and the picked one, on All tasks when nothing is
 * cached. The page reads the picked view from it and hands it to
 * `ViewToolbar` as `viewCollection`, so both share one.
 */
export const useTaskViewCollection = ({
    builtInTaskViews,
    isLoadingBuiltInTaskViews,
    cacheKeys,
}: {
    builtInTaskViews: Array<NamedView<TaskView>>;
    isLoadingBuiltInTaskViews: boolean;
    cacheKeys: TaskListCacheKeys;
}) =>
    useViewCollection({
        viewType: ViewType.TASK,
        builtInViews: builtInTaskViews,
        cacheKey: cacheKeys.baseViewId,
        fallbackBaseViewId: DEFAULT_VIEW_ID,
        isLoadingBuiltInViews: isLoadingBuiltInTaskViews,
    });
